import TrailDetailsShareOption from '../enums/TrailDetailsShareOption';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsShareThisTrailOptionClickedParams = {
  share_option_clicked?: TrailDetailsShareOption;
  trail_id?: string;
};

/**
 * User clicks one of the share options in the ‘share this link’ dropdown of the web trail page.
 * @param params - Attributes to log with the amplitude event
 * @param params.share_option_clicked - The option that the user clicked to share the trail page.
 * @param params.trail_id - Trail page user was on when they clicked the 'share this link' dropdown.
 */
const logTrailDetailsShareThisTrailOptionClicked = (
  { share_option_clicked, trail_id }: logTrailDetailsShareThisTrailOptionClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details share this trail option clicked',
    { 'share option clicked': share_option_clicked, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsShareThisTrailOptionClicked;
